<template>
    <div class="app-container mt-5" id="configuration">

        <div class="page-title mb-3" v-show="!$global.loading">
            <router-link to="/configuration/adhesion-management">
                <span class="breadcrumb-link">
                    Mes Bulletins
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                {{ configName }}
            </span>
            <v-icon @click="prepareNameUpdate" class="ml-2 text-primary">edit</v-icon>

            <v-chip v-if="isConfigured" class="ml-4" color="green" small>
                <span class="text-white">Configuré</span>
            </v-chip>
            <v-chip v-else class="ml-4" color="red" small>
                <span class="text-white">Non configuré</span>
            </v-chip>


            <div class="ms-auto">
                <v-btn class="custom-button-primary" outlined @click="openPreview">
                    <v-icon class="mr-2">remove_red_eye</v-icon>
                    Prévisualiser le bulletin
                </v-btn>
            </div>
        </div>

        <v-stepper @change="setCurrentStep" non-linear :value="currentStep" class="h-auto w-auto config-stepper mb-5">
            <v-stepper-header>
                <v-stepper-step editable step="1">
                        Questions
                </v-stepper-step>

                <v-stepper-step editable step="2">
                    Offres
                </v-stepper-step>

                <v-stepper-step editable step="3">
                    Options
                </v-stepper-step>

                <v-stepper-step editable step="4">
                    Informations supplémentaires
                </v-stepper-step>

                <v-stepper-step editable step="5">
                    Moyens de paiement
                </v-stepper-step>

                <v-stepper-step editable step="6">
                    Paramètres
                </v-stepper-step>

                <v-stepper-step editable step="7" v-if="!isConfigured">
                    <div>
                        <v-chip small color="warning" class="mr-2">
                            <span>
                            {{ missingRequiredDatasCount }}
                        </span>
                        </v-chip>
                        <span>Finalisation</span>
                    </div>
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content class="pt-0" step="1">
                    <question-tab></question-tab>
                </v-stepper-content>

                <v-stepper-content class="pt-0" step="2">
                    <cadh-config-offers></cadh-config-offers>
                </v-stepper-content>

                <v-stepper-content class="pt-0" step="3">
                    <cadh-config-options></cadh-config-options>
                </v-stepper-content>

                <v-stepper-content class="pt-0" step="4">
                    <cadh-config-informations></cadh-config-informations>
                </v-stepper-content>

                <v-stepper-content class="pt-5" step="5">
                    <cadh-config-means-of-payment></cadh-config-means-of-payment>
                </v-stepper-content>

                <v-stepper-content step="6" class="pt-0">
                    <cadh-config-parameters></cadh-config-parameters>
                </v-stepper-content>

                <v-stepper-content step="7" class="p-0" v-if="!isConfigured">
                    <cadh-config-check></cadh-config-check>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <v-dialog v-model="updateNameModal" max-width="400" style="{ 'zIndex': 200 }"
                  @keydown.esc="updateNameModal = false">
            <v-card>
                <v-toolbar dense flat>
                    <v-toolbar-title class="mt-6 ml-2">Modification du nom du bulletin</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="p-4">
                    <v-text-field
                      outlined
                      label="Nom du bulletin"
                      v-model="newName"
                      hide-details
                      :class="{'input-error': !nameIsNotNull && (newName === '' || newName === null)}"
                    ></v-text-field>
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="updateNameModal = false" class="mb-2 mr-2">
                        Annuler
                    </v-btn>
                    <v-btn class="default-button mr-3 mb-2" @click="checkName">
                        Modifier
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import QuestionTab from "./steppers/question/QuestionTab.vue"
import CadhConfigOffers from "./steppers/Offers"
import CadhConfigOptions from "./steppers/Options"
import CadhConfigInformations from "./steppers/Informations"
import CadhConfigMeansOfPayment from "./steppers/MeansOfPayment"
import CadhConfigParameters from "./steppers/Parameters"
import CadhConfigCheck from "./steppers/CadhConfigCheck.vue"

export default {
    name: "CadhConfigEdit",
    components: {
        QuestionTab, CadhConfigOffers, CadhConfigOptions, CadhConfigInformations, CadhConfigMeansOfPayment,
        CadhConfigParameters, CadhConfigCheck
    },
    data() {
        return {
            configId: null,
            updateNameModal: false,
            newName: "",
            nameIsNotNull: true,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setCurrentStep", "setCadhConfig", "resetState", "setOptionModal", "setName"]),
        openPreview() {
            let url = window.location.origin + "/cadh-preview/" + this.cadhConfig.token

            window.open(url)
        },
        prepareNameUpdate() {
            this.newName = this.configName
            this.updateNameModal = true
        },
        updateConfigName() {
            let payload = {
                "configId": this.cadhConfig.id,
                "newName": this.newName,
            }

            this.loading = true

            this.updateNameModal = false

            this.$store.dispatch("cadhConfig/updateName", payload)

            this.loading = false
        },
        checkName() {
            if (this.newName === "" || this.newName === null) {
                this.nameIsNotNull = false
            } else {
                this.nameIsNotNull = true
                this.updateConfigName()
            }
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "currentStep", "optionModal", "name", "criteriaFamilies",
            "isConfigured", "missingRequiredDatasCount"]),
        configName: {
            get() {
                return this.name
            },
            set(value) {
                this.setName(value)
            },
        },
    },
    async created() {
        this.resetState()
        this.configId = atob(this.$route.params.configId)

        this.$global.loading = true

        await this.$store.dispatch("cadhConfig/getCadhConfig", this.configId)

        await this.$store.dispatch("cadhConfig/getCadhFields")

        this.$global.loading = false

        this.setName(this.cadhConfig.name)
    },
}
</script>